import { toast } from "react-toastify";
import apiClient from "./apiClient";

/**
 * Append Details API For Host and Merchant
 * @param {string} userType - The type of user (e.g., "merchant", "host").
 * @param {string} id - The ID of the user.
 * @param {any} data - The data to be appended.
 * @returns {Promise<any>} - The response data.
 * @throws {Error} - If there's an error during the API call.
 **/
export const appendDetails = async (
  userType: string,
  id: string,
  data: any
) => {
  try {
    const type = userType === "Host" ? "Hosts" : "Merchants";
    const response = await apiClient.put(`/${type}/id/${id}`, data);
    return response.data;
  } catch (error) {
    toast.error("Error Updating details");
    console.error("Error Updating details:", error);
    throw error;
  }
};

/**
 * Fetch User Data for Merchant and Host
 * @param {string} userType - The type of user (e.g., "merchant", "host").
 * @param {string} id - The ID of the user.
 * @param {AbortSignal} Signal - The signal to abort the request.
 * @returns {Promise<any>} - The response data.
 * @throws {Error} - If there's an error during the API call.
 **/

export const getDetails = async (
  userType: string,
  id: string,
  Signal?: AbortSignal
) => {
  try {
    const response = await apiClient.get(`/${userType}/id/${id}`, {
      signal: Signal,
    });
    return response.data;
  } catch (error) {
    toast.error("Error getting details");
    console.error("Error getting details:", error);
    throw error;
  }
};

export const getHostById = async (id: string) => {
  const searchIdkey = id.slice(0, 10);
  const searchId = id.slice(10);
  const data = {
    filterParams: {
      IndexName: "searchIdKey-searchId-index",
      KeyConditionExpression:
        "searchIdKey = :searchIdKey and searchId = :searchId",
      ExpressionAttributeValues: {
        ":searchIdKey": searchIdkey,
        ":searchId": searchId,
      },
    },
  };
  try {
    const response = await apiClient.post(`/Hosts/bulk-ops/query`, data);

    if (
      response.status !== 200 ||
      !response.data ||
      response.data.length === 0
    ) {
      toast.error("Host not found. Please check the ID.");
      return null;
    }

    const host = response.data[0];

    return {
      name: host?.hostBasicDetails?.fullName || "Not Available",
      approvalStatus: host?.hostApprovalStatus || "Unknown",
      mobileNumber: host?.mobileNumber || "N/A",
    };
  } catch (error) {
    console.error("Error fetching host details:", error);
    toast.error("Failed to fetch host details. Please try again.");
    return null;
  }
};

export const getReviewById = async (id: string) => {
  try {
    const data:any = {
      filterParams: {
        IndexName: "merchantId-index",
        KeyConditionExpression: "merchantId = :merchantId",
        ExpressionAttributeValues: {
          ":merchantId": id,
        },
      },
    };

    const response = await apiClient.post('/RatingsAndReviews/bulk-ops/query', data);
    return response.data;
    
  } catch (error) {
    console.error("Error fetching review details:", error);
    throw error;
  }
};
